import React, {forwardRef, useCallback, useEffect, useState} from "react";
import {AutoComplete, Button, ButtonToolbar, DatePicker, Form, Modal, SelectPicker} from 'rsuite';
import {deleteUserDegree, updateUserDegree} from "../../../service/degreeService";
import {educationModel} from "../../form/models";
import {commonMajors} from "../../constants/commonMajors";

const dateEarnedInstance = forwardRef((props, ref) =>
    <DatePicker oneTap format="yyyy-MM" ranges={[]} style={{width: 200}} ref={ref} {...props} />
);

const EditEducationModal = (props) => {

    const { open, handleClose, degree, degrees } = props;

    const [localState, setLocalState] = useState({});

    const submitDegreeEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserDegree(localState).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    const submitDegreeDelete = useCallback(() => {
        deleteUserDegree({id: localState.id, userId: localState.userId}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    useEffect(() => {
        setLocalState({...degree});
    }, [degree]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Edit Degree</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={educationModel}
                onChange={handleFormChange}
                onSubmit={submitDegreeEdit}
                formDefaultValue={degree}
            >
                <Form.Group>
                    <Form.ControlLabel>Degree Name</Form.ControlLabel>
                    <Form.Control name="degreeName"
                                  accepter={SelectPicker}
                                  data={degrees}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Institution</Form.ControlLabel>
                    <Form.Control name="institution"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Major</Form.ControlLabel>
                    <Form.Control name="major"
                                  accepter={AutoComplete}
                                  data={commonMajors}
                                  style={{width: 300}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Minor</Form.ControlLabel>
                    <Form.Control name="minor" />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Date Earned</Form.ControlLabel>
                    <Form.Control name="dateEarned"  accepter={dateEarnedInstance}/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitDegreeDelete} appearance="primary" color="red">
                            Delete Degree
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default EditEducationModal;